import React from 'react'
import { BsFacebook, BsInstagram, BsYoutube, BsTelegram } from "react-icons/bs";
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div className='items-center'>
    <footer className="p-10 mt-16 bg-amber-400">
        
        <div>
          <div>
            <ul className="flex flex-row justify-around py-10">
              <li className="cursor-pointer">
                <a className = 'text-blue-400 hover:text-blue-600' href="#" target='_blank'>
                  {" "}
                  <BsFacebook size={30} />
                </a>
              </li>
              <li className="cursor-pointer">
                <a className = 'text-red-400 hover:text-red-600' href="#" target='_blank'>
                  {" "}
                  <BsYoutube size={30} />
                </a>
              </li>
              <li className="cursor-pointer focus">
                <a className = 'text-blue-400 hover:text-blue-600' href="#" target='_blank'>
                  {" "}
                  <BsTelegram size={30} />
                </a>
              </li>
              <li className="cursor-pointer focus">
              <a className = 'text-blue-400 hover:text-blue-600' href="#" target='_blank'>
                {" "}
                <BsInstagram size={30} />
              </a>
            </li>
          
            </ul>
          </div>
        </div>
      
        <p className="text-center font-bold py-4">Copyright © {new Date().getFullYear()} Netsi's Kitchen </p>       <p className="text-center font-bold text-black">Powered by <a href="https://codezola.com/" target="_blank" className='text-blue-600'>CodeZola</a></p>
    </footer>
    </div>
  )
}

export default Footer